import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import {
  MyDocumentsInfoCardItem,
  MyDocumentsDocumentEditorButtons,
  MyDocumentsDocumentVisibility,
  MassUploadCollapse,
} from "my-documents/components";
import { OcConfirmationDialog } from "oc/components";
import { getFormatBytes } from "oc/utils";
import parsePipedName from "oc/utils/get-parse-pipedName";

interface Document {
  _id: string;
  filename: string;
  size: number;
  description: string;
  user: string;
}

interface MyDocumentsCollapseProps {
  row: {
    size?: number;
    user?: string;
    userView?: boolean;
    documents?: Document[];
    documentCount?: number;
    massUploadId?: string;
    rowIndex?: number;
  };
  isNotExaminer: boolean;
  removeUpload: (row: any) => void;
  onEditDocument: (row: any) => void;
  removeMassUpload?: (row: any) => void;
}

export const MyDocumentsCollapse: React.FC<MyDocumentsCollapseProps> = ({
  row,
  isNotExaminer,
  removeUpload,
  onEditDocument,
  removeMassUpload,
}) => {
  const { t, i18n } = useTranslation();

  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const handleDialogCancel = () => {
    setShowConfirmDialog(false);
  };

  // Check if this is a mass upload history row - delegate to MassUploadCollapse
  if (row?.documents && Array.isArray(row.documents)) {
    return (
      <MassUploadCollapse
        row={row}
        isNotExaminer={isNotExaminer}
        removeMassUpload={removeMassUpload || (() => {})}
        rowIndex={row.rowIndex}
      />
    );
  }

  // Regular document collapse
  return (
    <>
      <OcConfirmationDialog
        showDialog={showConfirmDialog}
        onClose={() => {
          removeUpload(row);
        }}
        onCancel={handleDialogCancel}
        title={t("OC_DELETE_CONFIRM")}
        texts={[t("MY_DOCUMENTS_DELETE_CONFIRM_INFO")]}
        okButtonText={t("OC_ALL_RIGHT")}
        cancelButtonText={t("OC_CANCEL")}
      />
      <Box padding="16px">
        <Box>
          <MyDocumentsInfoCardItem
            title={t("MY_DOCUMENTS_SIZE")}
            value={getFormatBytes(row?.size || 0)}
          />
          <Box height="10px" />
          <MyDocumentsInfoCardItem
            title={t("MY_DOCUMENTS_UPLOADER")}
            value={parsePipedName(row?.user || "", i18n) ?? ""}
          />
          {!isNotExaminer && (
            <Box>
              <Box height="18px" />
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <MyDocumentsDocumentVisibility visibility={row?.userView || false} />
                <MyDocumentsDocumentEditorButtons
                  setShowConfirmDialog={setShowConfirmDialog}
                  onEditDocument={onEditDocument}
                  row={row}
                />
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
};

export default MyDocumentsCollapse;
